import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from '@mui/material';

import {
  changeSearchQuery,
  markSelectedDomains,
  toggleGlobalRank,
  toggleVisibilitySelectedDomains,
} from '../../redux/sonar/sonarReducer';
import CommonSwitch from '../../components/common-switch/CommonSwitch';
import CommonButton from '../../components/common-button/CommonButton';
import { selectIsAnySelected } from '../../redux/sonar/sonarSelectors';

import scss from './SonarTable.module.scss';
import SearchInput from '../../components/common-inputs/SearchInput';

function SonarTableActions({ isDedicated, disableGlobalRank }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('sonar');
  const isTablet = useMediaQuery('(max-width: 1440px)');

  const isAnySelected = useSelector(selectIsAnySelected);
  const isShowGlobalRank = useSelector((state) => state.sonarDashboard.isShowGlobalRank);
  const searchQuery = useSelector((state) => state.sonarDashboard.sonarTable.searchQuery);

  const handleChangeSearch = (newSearch) => {
    dispatch(changeSearchQuery(newSearch));
  };

  const handleMarkDomains = (mark) => {
    dispatch(markSelectedDomains(mark));
  };

  const handleToggleVisibilityDomains = (isActive) => {
    dispatch(toggleVisibilitySelectedDomains(isActive));
  };

  const handleToggleGlobalRank = () => {
    dispatch(toggleGlobalRank());
  };

  return (
    <div className={scss.tableActions}>
      <SearchInput size='sm' value={searchQuery} onChange={handleChangeSearch} maxWidth={320} />

      {isDedicated && !disableGlobalRank ? (
        <label htmlFor='globalRank' className={scss.switchLabel}>
          <span>{`${t('rankGlobal')}:`}</span>
          <CommonSwitch name='globalRank' checked={isShowGlobalRank} onChange={handleToggleGlobalRank} />
        </label>
      ) : null}

      {!isDedicated || isTablet ? (
        <div className={scss.tableActionsButtons}>
          <CommonButton
            styleColor='secondary'
            type='button'
            disabled={!isAnySelected}
            onClick={() => handleMarkDomains(true)}>
            {t('mark')}
          </CommonButton>
          <CommonButton
            styleColor='secondary'
            type='button'
            disabled={!isAnySelected}
            onClick={() => handleMarkDomains(false)}>
            {t('unmark')}
          </CommonButton>
          <CommonButton
            styleColor='secondary'
            type='button'
            disabled={!isAnySelected}
            onClick={() => handleToggleVisibilityDomains(true)}>
            {t('show')}
          </CommonButton>
          <CommonButton
            styleColor='secondary'
            type='button'
            disabled={!isAnySelected}
            onClick={() => handleToggleVisibilityDomains(false)}>
            {t('hide')}
          </CommonButton>
        </div>
      ) : null}
    </div>
  );
}

export default SonarTableActions;
